var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isEnabledToShow,
          expression: "isEnabledToShow"
        }
      ],
      staticClass: "flat-switch-content"
    },
    [
      _c(
        "div",
        { staticClass: "rows" },
        [
          _c(
            "h2",
            {
              staticClass:
                "subtitle has-text-weight-bold has-text-primary is-size-5"
            },
            [_vm._v("\n      Ativar cotações no modo de validação?\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flat-switch" },
            [
              _c("p", { staticClass: " is-size-10 p-switch" }, [
                _vm._v(" " + _vm._s("Desativado"))
              ]),
              _vm._v(" "),
              _vm.reset
                ? _c(
                    "sc-field",
                    [
                      _c("sc-switch", {
                        on: { input: _vm.toggleCommit },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: " is-size-10" }, [
                _vm._v(" " + _vm._s("Ativo") + " ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("sc-collapse", [
            _c(
              "div",
              {
                staticClass: "panel-heading",
                attrs: {
                  slot: "trigger",
                  role: "button",
                  "aria-controls": "contentIdForA11y2"
                },
                slot: "trigger"
              },
              [
                _c("sc-icon", {
                  staticClass: "additional-information__icon",
                  attrs: { icon: "info-circle", size: "is-small" }
                }),
                _vm._v(" "),
                _c("strong", [_vm._v("O que é isso ?")])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "panel-block" }, [
              _c("p", [
                _vm._v(
                  "\n          Essa funcionalidade serve para disponibilizar em tempo real a consulta \n          dos detalhes de cotações que foram realizadas fora do TMS. \n          Habilite-a, realize suas cotações fora da plataforma e visualize os detalhes logo em seguida. "
                ),
                _c("br"),
                _vm._v(
                  "\n          Caso a cotação seja feita aqui no TMS, não é necessário ativar essa funcionalidade, já que o detalhe de todas as cotações são disponibilizadas em tempo real.."
                ),
                _c("br")
              ])
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15e48f08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e48f08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-real-time-quotation/ScRealTimeQuotation.vue
// module id = null
// module chunks = 